// extracted by mini-css-extract-plugin
export var active = "productfinder-tgs-module--active--b826f";
export var error_message = "productfinder-tgs-module--error_message--fb525";
export var errors = "productfinder-tgs-module--errors--4e907";
export var infoBox = "productfinder-tgs-module--infoBox--0586b";
export var input_section = "productfinder-tgs-module--input_section--3eef0";
export var location_link = "productfinder-tgs-module--location_link--633b6";
export var map_styles = "productfinder-tgs-module--map_styles--3fa8d";
export var product_category_container = "productfinder-tgs-module--product_category_container--41372";
export var product_results = "productfinder-tgs-module--product_results--7387c";
export var scroll = "productfinder-tgs-module--scroll--5d41e";
export var search = "productfinder-tgs-module--search--664b5";
export var search_section = "productfinder-tgs-module--search_section--db1da";
export var two_columns = "productfinder-tgs-module--two_columns--66a02";